import React, { useEffect, useState } from 'react';
import { Card, Result, Spin } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../services/api';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
`;

const VerifyCard = styled(Card)`
  width: 400px;
  text-align: center;
`;

const VerifyEmail: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('无效的验证链接');
        setVerifying(false);
        return;
      }

      try {
        await auth.verifyEmail(token);
        setVerifying(false);
        // 5秒后跳转到登录页
        setTimeout(() => {
          navigate('/auth');
        }, 5000);
      } catch (error: any) {
        setError(error.response?.data?.detail || '验证失败，请重试');
        setVerifying(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <PageContainer>
      <VerifyCard>
        {verifying ? (
          <Result
            icon={<Spin size="large" />}
            title="正在验证邮箱..."
          />
        ) : error ? (
          <Result
            status="error"
            title="验证失败"
            subTitle={error}
          />
        ) : (
          <Result
            status="success"
            title="邮箱验证成功"
            subTitle={
              <div>
                <p>您的邮箱已验证成功!</p>
                <p>现在您可以使用您的账号登录了。</p>
                <p>5秒后将自动跳转到登录页面...</p>
              </div>
            }
          />
        )}
      </VerifyCard>
    </PageContainer>
  );
};

export default VerifyEmail; 